/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  filtering: {
    position: 'absolute',
    right: 38,
    top: 0,
    width: 280,
  },
}));
